import logo from './logo.svg';
import './App.css';
import Login from './componenets/Login';
import { Navigate, Route, Routes } from 'react-router-dom';


import Navbars from './componenets/Pdfnav';
import Home from './componenets/home';

import Pdfextracter from './componenets/pdfextracter';
import Pdfchanges from './componenets/Pdfchanges';
import Pdfchanges2 from './componenets/pdfchanges2';
import Pdfjs from './componenets/pdfjs';
import Pdfjs1 from './componenets/pdfjs1';
import Pdfjs1s from './componenets/Rough';
import Pdfjs1v1 from './componenets/Pdfjs1v1';
import Newcheck from './componenets/newcheck';
import Pdfjs1v2 from './componenets/Pdfjsv2';
import Pdfpages from './componenets/pdfpage';
import Pd from './componenets/24';
import Pdfpages2 from './componenets/Pdfpage2';
import Temp from './componenets/temp';
import Loginnew from './componenets/loginnew';
import Temp2 from './componenets/temp2';
import Temp3 from './componenets/temp3';
import EmployeeGrid from './componenets/grid';
import EmployeeGrid2 from './componenets/Grid2';




function App() {
  return (
    <div className="App">
      <Navbars/>
      {/* <PDF/> */}
      <Routes>
        {/* <Route path="/" element={<Pdfjs1v1/>} /> */}
        {/*main <Route path="/" element={<Pdfjs1v1/>} /> */}
         {/* <Route path="/" element={<Pdfextracter/>} /> */}



        {/* <Route path="/" element={<Pdfpages/>} /> */}

        
        <Route path="/" element={<Login/>} />

        
        {/* <Route path="/new" element={<Loginnew/>} /> */}

        
       {/* <Route path="/pdfextracter" element={<Pdfchanges/>} /> */}




       {/* <Route path="/pdfextracter2" element={<Pdfpages/>} />

       <Route path="/temp" element={<Temp/>} /> */}
       <Route path="/temp2" element={<Temp2/>} />
      
       <Route path="/grid" element={<EmployeeGrid/>} />
       {/* <Route path="/temp3" element={<Temp3/>} /> */}




        {/* <Route path="/employees" element={<Listemployee />} /> */}
        {/* <Route path="/addemp" element={<Addemployee />} />
        <Route path="/update/:id" element={<Addemployee />} /> */}
      </Routes>
     
      
    </div>
  );
}

export default App;
